module.exports = __webpack_public_path__ + "img/黃槿謙德_四方連續_線稿_black.954d84c4.png";